import React from 'react';
import Avatar from '@justgiving/avatar';
import { Trans } from 'react-i18next';

import './MemberDetails.scss';
import UserListItem from '../UserListItem/UserListItem';
import PATHS from '../../constants/paths';
import { withTrack, WithTrack } from '../../utils/analytics';
import MemberTotals from '../MemberTotals/MemberTotals';
import classNames from 'classnames';
import { PageStatus } from '../../../types/__generated__';

export type MemberDetailsProps = WithTrack & {
  name: string;
  picture?: string;
  fundraisingPageShortName: string;
  fundraisingPageName: string;
  fundraisingPageIndex: number;
  fundraisingPagesCount: number;
  fundraisingPageStatus: string;
  fundraisingPageTargetAmount: number;
  fundraisingPageRaisedAmount: number;
  fundraisingPageCurrencyCode: string;
};

export class MemberDetails extends React.PureComponent<MemberDetailsProps> {
  getTrackingData = () => {
    const {
      fundraisingPageIndex,
      fundraisingPageShortName,
      fundraisingPagesCount,
    } = this.props;

    return {
      event: 'card click',
      action_name: 'card click',
      subtype: 'fundraising page',
      sub_section: 'team members',
      card_rank: fundraisingPageIndex,
      card_count: fundraisingPagesCount,
      card_url: `${PATHS.FRP}${fundraisingPageShortName}`,
    };
  };

  trackClickFRP = () => {
    const { track } = this.props;

    const trackingData = {
      event_value: 'team member',
      ...this.getTrackingData(),
    };
    track(trackingData);
  };

  trackClickDonate = () => {
    const { track } = this.props;

    const trackingData = {
      event_value: 'donate',
      ...this.getTrackingData(),
    };
    track(trackingData);
  };

  render() {
    const {
      name,
      picture,
      fundraisingPageShortName,
      fundraisingPageName,
      fundraisingPageStatus,
      fundraisingPageTargetAmount,
      fundraisingPageRaisedAmount,
      fundraisingPageCurrencyCode,
    } = this.props;

    return (
      <UserListItem
        picture={
          <a
            href={`${PATHS.FRP}${fundraisingPageShortName}`}
            tabIndex={-1}
            onClick={this.trackClickFRP}
          >
            <Avatar avatarSize="auto" picture={picture} />
            <span className="jg-sr-only"> - {fundraisingPageName}</span>
          </a>
        }
      >
        <div className="jg-pages-memberdetails">
          <a
            href={`${PATHS.FRP}${fundraisingPageShortName}`}
            className={classNames(
              'jg-flex-g1',
              'jg-space-mbxs',
              'jg-text--large-regular',
            )}
            onClick={this.trackClickFRP}
          >
            {name}
            <span className="jg-sr-only"> - {fundraisingPageName}</span>
          </a>

          <MemberTotals
            targetAmount={fundraisingPageTargetAmount}
            raisedAmount={fundraisingPageRaisedAmount}
            currencyCode={fundraisingPageCurrencyCode}
          />

          <div className="jg-pages-memberdetails-donate">
            {fundraisingPageShortName &&
              fundraisingPageStatus === PageStatus.Active && (
                <a
                  href={`${PATHS.FRP}${fundraisingPageShortName}/donate`}
                  data-qa="frp-donate"
                  className={classNames(
                    'jg-display-b',
                    'jg-text--large-regular',
                    'jg-text-color-branded',
                  )}
                  onClick={this.trackClickDonate}
                >
                  <Trans i18nKey="common.donateLink">Donate</Trans>
                </a>
              )}
          </div>
        </div>
      </UserListItem>
    );
  }
}

export default withTrack(MemberDetails);
